import React from 'react'
import "./Department.css"
import { useEffect, useRef, useState } from 'react';

const Department = () => {
  const canvasRef = useRef(null);
  const [selectedBarIndex, setSelectedBarIndex] = useState(null);

  function roundRect(ctx, x, y, width, height, borderRadius, backgroundColor) {
    ctx.beginPath();
    ctx.fillStyle = backgroundColor;
    ctx.moveTo(x + borderRadius, y);
    ctx.lineTo(x + width - borderRadius, y);
    ctx.quadraticCurveTo(x + width, y, x + width, y + borderRadius);
    ctx.lineTo(x + width, y + height - borderRadius);
    ctx.quadraticCurveTo(x + width, y + height, x + width - borderRadius, y + height);
    ctx.lineTo(x + borderRadius, y + height);
    ctx.quadraticCurveTo(x, y + height, x, y + height - borderRadius);
    ctx.lineTo(x, y + borderRadius);
    ctx.quadraticCurveTo(x, y, x + borderRadius, y);
    ctx.closePath();
    ctx.fill();
  }
  // Chart data
  const data = [
    { value: 83, color: "#004F95", bgColorRight: "#ADCCE9", title: 'Laboratory' },
    { value: 59, color: "#3DA5D9", bgColorRight: "#ADCCE9", title: 'Radiology' },
    { value: 95, color: "#73BFB8", bgColorRight: "#ADCCE9", title: 'ICU' },
    { value: 78, color: "#FEC601", bgColorRight: "#ADCCE9", title: 'Operation' },
    { value: 46, color: "#EA7317", bgColorRight: "#ADCCE9", title: 'OPD' },
  ];
  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext('2d');



    // Chart options
    const options = {
      chartArea: { left: 0, top: 30, right: 0, bottom: 60 },
      width: 260,
      height: 280,
      barPadding: 20,
      barColor: '#F8FBFF',
    };

    // Calculate chart dimensions
    const chartWidth = options.width - options.chartArea.left - options.chartArea.right;
    const chartHeight = options.height - options.chartArea.top - options.chartArea.bottom;

    // Find the maximum value in the data
    const maxValue = Math.max(...data.map(item => item.value));

    // Calculate the width of each bar based on the maximum value
    const barWidth = chartWidth / maxValue;

    // Clear canvas
    ctx.clearRect(0, 0, options.width, options.height);

    // Draw bars
    data.forEach((item, index) => {
      const barX = options.chartArea.left;
      const barY = options.chartArea.top + index * (options.barPadding + chartHeight / data.length);
      const barHeight = chartHeight / data.length - options.barPadding;

      // Draw background color
      ctx.fillStyle = item.bgColorRight;
      roundRect(ctx, barX, barY, options.width - options.chartArea.right - barX, barHeight, 13, item.bgColorRight);

      // Draw bar
      ctx.fillStyle = item.color;
      roundRect(ctx, barX, barY, item.value * barWidth, barHeight, 13, item.color);
    });

    const handleClick = (event) => {
      const rect = canvas.getBoundingClientRect();
      const x = event.clientX - rect.left;
      const y = event.clientY - rect.top;

      let clickedBarIndex = null;

      data.forEach((item, index) => {
        const barX = options.chartArea.left;
        const barY = options.chartArea.top + index * (options.barPadding + chartHeight / data.length);
        const barHeight = chartHeight / data.length - options.barPadding;

        if (x >= barX && x <= barX + item.value * barWidth && y >= barY && y <= barY + barHeight) {
          clickedBarIndex = index;
        }
      });

      setSelectedBarIndex(clickedBarIndex);
    };

    canvas.addEventListener('click', handleClick);

    return () => {
      canvas.removeEventListener('click', handleClick);
    };
    
  }, [data]);

  return (
    <div className='card_dept'>
      <h4 className='exp_deptD'>Departments</h4>
      <div class="btn-group_Dept">
        <button style={{ background: "#004F95", color: "white" }}></button>
        <button style={{ background: "#3DA5D9", color: "white" }}></button>
        <button style={{ background: "#73BFB8", color: "white" }}></button>
        <button style={{ background: "#FEC601", color: "white" }}></button>
        <button style={{ background: "#EA7317", color: "white" }}></button>
      </div>

      <div >
        <canvas className="chart_Deptments" ref={canvasRef} width="260" height="280"></canvas>
        {selectedBarIndex !== null && (
          <div className="popup_dept" style={{ top: selectedBarIndex * 80 + 40 }}>
            <div className="popup-title_dp">
              <h3>{data[selectedBarIndex].title}</h3>
            </div>
          </div>
        )}
      </div>
      <div className='Laboratory'>Laboratory</div>
      <div className='Laboratory_1'>Radiology</div>
      <div className='Laboratory_12'>ICU</div>
      <div className='Laboratory_123'>Operation</div>
      <div className='Laboratory_1234'>OPD</div>
      <div className='exp_see'>See More</div>

      <div className='Laboratory_91'>91</div>
      <div className='Laboratory_53'>53</div>
      <div className='Laboratory_98'>98</div>
      <div className='Laboratory_75'>75</div>
      <div className='Laboratory_36'>36</div>
    </div>
  )
}

export default Department
